export default "__VITE_ASSET__BLpa66AG__"